import { combineReducers } from "redux"

import userAccountInfoReducer from "./userAccountInfo"
import systemSettingsReducer from "./systemSettings"

export default combineReducers({
  userAccountInfo: userAccountInfoReducer,
  systemSettings: systemSettingsReducer
})